import { NamedNode } from './node';
import { Entry } from './entry';

export class Area extends NamedNode {
    entries?: Entry[];
    capacity?: number;
    occupied?: number;
    recoveryMode?: boolean;
}
